var React = require('react');

function CloseMenu (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.251051 0.251051C0.585786 -0.0836838 1.1285 -0.0836838 1.46323 0.251051L19.749 18.5368C20.0837 18.8715 20.0837 19.4142 19.749 19.749C19.4142 20.0837 18.8715 20.0837 18.5368 19.749L0.251051 1.46323C-0.0836838 1.1285 -0.0836838 0.585786 0.251051 0.251051Z","fill":"#262626","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M19.749 0.251051C20.0837 0.585786 20.0837 1.1285 19.749 1.46323L1.46323 19.749C1.1285 20.0837 0.585786 20.0837 0.251051 19.749C-0.0836838 19.4142 -0.0836838 18.8715 0.251051 18.5368L18.5368 0.251051C18.8715 -0.0836838 19.4142 -0.0836838 19.749 0.251051Z","fill":"#262626","key":1})]);
}

CloseMenu.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = CloseMenu;

CloseMenu.default = CloseMenu;
